import { Helmet } from 'react-helmet-async';

/**
 * SEO Component for baglamasatinal.com
 * Her sayfada dinamik meta taglar için kullanılır
 */
const SEO = ({ 
  title, 
  description, 
  keywords = '',
  canonical = '',
  image = '/og-image.png',
  type = 'website',
  noindex = false,
  jsonLd = null
}) => {
  const baseUrl = 'https://baglamasatinal.com';
  const siteName = 'Bağlama Satın Al';
  const defaultDescription = 'Yapay zeka destekli bağlama satın alma danışmanı. Seviyenize, bütçenize ve tercihlerinize göre en uygun saz önerileri.';
  const defaultKeywords = 'bağlama satın al, saz satın al, bağlama fiyatları, kısa sap bağlama, uzun sap bağlama, bağlama dersi, online saz dersi';
  
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Yapay Zeka Destekli Saz Öneri Sistemi`;
  const fullDescription = description || defaultDescription;
  const fullKeywords = keywords || defaultKeywords;
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const fullImage = image.startsWith('http') ? image : `${baseUrl}${image}`;

  return (
    <Helmet>
      {/* Temel Meta Taglar */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      <link rel="canonical" href={fullCanonical} />
      
      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="tr_TR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Sayfa bazlı JSON-LD structured data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
